import { Navigate, Outlet } from "react-router-dom";

const B2BRoute = () => {
    const token = localStorage.getItem("Auth Token");
    const authorisation = localStorage.getItem("authorisation_type");

    return (
        token && authorisation === 'b2b' ? <Outlet/> : <Navigate to='/login' />
    )
}

export default B2BRoute;